import PropTypes from 'prop-types'
import React from 'react'
import { FormattedMessage } from 'react-intl'

import * as ErrorUtils from '@/checkout-instore-legacy/utils/ErrorUtils'

function SearchError({ term, errors, retrySearch }) {
  return (
    <div className="flex flex-column justify-center aspect-ratio--object tc pa5 pa7-ns f3-ns">
      <div className="flex-none mb5 mb6-ns lh-copy gray">
        <FormattedMessage id="errorSearchingFor" />
        <strong>{term}</strong>
      </div>
      <div className="flex-none mb6 mb7-ns lh-copy light-red">
        <div className="error-items">
          {errors.map((error, i) => {
            return (
              <div key={i}>
                <div>{ErrorUtils.getErrorMessage(error)}</div>
                {error.responseMessage ? (
                  <div>{error.responseMessage}</div>
                ) : (
                  ''
                )}
              </div>
            )
          })}
        </div>
      </div>
      <button
        className="flex-none bg-green white bn f4 f3-ns pv5 pv6-ns ph6 ph7-ns center"
        onClick={retrySearch}
      >
        <FormattedMessage id="searchTryAgain" />
      </button>
    </div>
  )
}

SearchError.propTypes = {
  term: PropTypes.string,
  errors: PropTypes.object,
  retrySearch: PropTypes.func,
}

export default SearchError
